<lms-button-actions>
  <div class="gl-context-menu__options">
    <ng-container>
      <span
        *lmsProfileGuard="'subscriptions.create'"
        class="gl-context-menu__options--item"
        (click)="openSubscriptionEditor()"
      >
        {{ (!hasSubscription ? 'subscriptions.create' : 'subscriptions.modify') | translate }}
      </span>
      <ng-container *lmsProfileGuard="'subscriptions.create'">
        <span *ngIf="hasSubscription" class="gl-context-menu__options--item" (click)="openRenewalEditor()">
          {{ (subscriptionRenewal ? 'subscriptions.modifyRenew' : 'subscriptions.renew') | translate }}
        </span>
      </ng-container>
      <ng-container *ngIf="hasSubscription">
        <span
          *lmsProfileGuard="'subscriptions.downloadSeatsReport'"
          class="gl-context-menu__options--item"
          (click)="downloadSeatsReport()"
          >{{ 'subscriptions.seatsReportView' | translate }}</span
        >
      </ng-container>
      <ng-container *ngIf="hasSubscription">
        <span
          *lmsProfileGuard="'subscriptions.delete'"
          class="gl-context-menu__options--item alert"
          (click)="deleteSubscription()"
          >{{ 'actions.deleteSubscription' | translate }}</span
        >
      </ng-container>
    </ng-container>
  </div>
</lms-button-actions>

<lms-modal class="gl-modal__small" #modalSubscriptionForm>
  <div class="gl-modal__header">
    <div class="gl-modal__title">
      {{
        'subscriptions.modalTitle.' + (isSubscriptionRenewal ? 'renew' : hasSubscription ? 'modify' : 'create')
          | translate
      }}
    </div>
    <div class="gl-modal__close" (click)="onCancel()">
      <span class="glicon-close"></span>
    </div>
  </div>

  <lms-dynamic-form [questions]="questions" [options]="{ disableCard: true }" (submit)="onSubmit($event)" #dynamicForm>
    <ng-container *lmsProfileGuard="'subscriptions.delete'" form-actions-before>
      <gl-button
        *ngIf="isSubscriptionRenewal && subscriptionRenewal"
        color-tertiary
        [text]="'subscriptions.deleteRenewal' | translate"
        (onClick)="deleteSubscriptionRenewal()"
      >
      </gl-button>
    </ng-container>
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="onCancel()" form-actions-before>
    </gl-button>
  </lms-dynamic-form>
</lms-modal>
